export default "__VITE_ASSET__BKQ3a0cf__"